import { KeywordTableColumnSize, KeywordTableColumnTypes } from './models';

export const getColumnDefaultSize = (type: KeywordTableColumnTypes): KeywordTableColumnSize => {
  // Size XS
  if ([KeywordTableColumnTypes.VolumeLast12months].includes(type)) return KeywordTableColumnSize.xs;

  // Size SM
  if (
    [
      KeywordTableColumnTypes.VolumeTrend,
      KeywordTableColumnTypes.Competition,
      KeywordTableColumnTypes.Cpc,
      KeywordTableColumnTypes.CpcBidHigh,
      KeywordTableColumnTypes.CpcBidLow,
      KeywordTableColumnTypes.TagCount,
    ].includes(type)
  )
    return KeywordTableColumnSize.sm;

  // Size MD
  if (
    [
      KeywordTableColumnTypes.Volume,
      KeywordTableColumnTypes.RankStatus,
      KeywordTableColumnTypes.VolumeMonthPeak,
      KeywordTableColumnTypes.VolumeQuarterPeak,
    ].includes(type)
  )
    return KeywordTableColumnSize.md;

  // Size LG
  if (
    [
      KeywordTableColumnTypes.Rank,
      KeywordTableColumnTypes.TagGroup,
      KeywordTableColumnTypes.SerpFeatures,
      KeywordTableColumnTypes.ArchiveTime,
      KeywordTableColumnTypes.EnglishTranslation,
      KeywordTableColumnTypes.TranslationFrom,
      KeywordTableColumnTypes.TranslationFromVolume,
      KeywordTableColumnTypes.SeedKeyword,
      KeywordTableColumnTypes.SeedType,
    ].includes(type)
  )
    return KeywordTableColumnSize.lg;

  // Size XL
  if ([KeywordTableColumnTypes.Keyword, KeywordTableColumnTypes.KeywordSearch].includes(type))
    return KeywordTableColumnSize.xl;

  // Else none
  return KeywordTableColumnSize.none;
};
